export const filterDropdownItems = [
  { value: 'lowpass', label: 'lowpass' },
  { value: 'highpass', label: 'highpass' },
  { value: 'bandpass', label: 'bandpass' },
  { value: 'lowshelf', label: 'lowshelf' },
  { value: 'highshelf', label: 'highshelf' },
  { value: 'peaking', label: 'peaking' },
  { value: 'notch', label: 'notch' },
  { value: 'allpass', label: 'allpass' },
]